import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/admin/adminAuthentication/adminAuth.css";
import AppContext from "../../../context/AppContext";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { baseUrl, validateForm,getadmin,setadmin } = useContext(AppContext); 
  const {setAuthToken} = useContext(AppContext);
  const [admemail, setAdmemail] = useState("");
  const [admpassword, setAdmpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  
  const loginhandle = (e) => {
    e.preventDefault();

    const { isValid, errors } = validateForm([
      { field: 'admemail',    type: 'email',    value: admemail },
      { field: 'admpassword', type: 'password', value: admpassword },
    ]);
    setFieldErrors(errors);
    if (!isValid) return;

    setLoading(true);
    setError("");
    
    const formdata = new FormData();
    formdata.append("admemail", admemail);
    formdata.append("admpassword", admpassword);
    
    axios.post(`${baseUrl}/admin/login`, formdata, { 
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then((response) => {
      if(response.data.admaccount_status == 'inactive') {
        alert('your account is inactive');
      }
      if(response.data.success) { 
        localStorage.setItem("adminEmail", admemail);
        localStorage.setItem("adminPassword", admpassword);
        localStorage.setItem("authToken", response.data.token);
        setAuthToken(response.data.token)
        localStorage.setItem("adminName", response.data.admin.admusername);
        localStorage.setItem("adminRole", response.data.admin.admrole);
        
        navigate("/admin/dashboard"); 
      } else {
        setError(response.data.message || "Login failed");
      }
      setLoading(false);
    })
    .catch((error) => {
      setError(error.response?.data?.message || "Login failed. Please try again.");
      setLoading(false);
    });
  };

  const adminAutoLogin = (em,pw) => {
    const formdata = new FormData();
    formdata.append("admemail", em);
    formdata.append("admpassword", pw);
    axios.post(`${baseUrl}/admin/login`, formdata, { 
      headers: {
        "Content-Type": "multipart/form-data" 
      }
    })
    .then((response) => {
      console.log(response.data);
      if(response.data.success) { 
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("adminName", response.data.admin.admusername);
        localStorage.setItem("adminRole", response.data.admin.admrole);
        localStorage.setItem("adminEmail", response.data.admin.admemail);
        localStorage.setItem("adminRole", response.data.admin.admrole);
        setAuthToken(response.data.token)
        navigate("/admin/dashboard"); 
      } else {
        setError(response.data.message || "Login failed");
        setPageLoading(false);
      }
      setLoading(false);
    })
    .catch((error) => {
      setError(error.response?.data?.message || "Login failed. Please try again.");
      setLoading(false);
      setPageLoading(false);
    });
  };

  useEffect(()=>{
    setPageLoading(true);
    const storedAdmemail = localStorage.getItem("adminEmail");
    const storedAdmpassword = localStorage.getItem("adminPassword");
    if(storedAdmemail != null && storedAdmpassword != null) {
      adminAutoLogin(storedAdmemail, storedAdmpassword);
    } else {
      setPageLoading(false);
    }
  },[]);

  return (
    pageLoading ? 
    <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center">
      <Spinner style={{fontSize:100}} />
    </div>
    :
    <div className="adm-auth-wrapper">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={5}>
            <Card className="adm-auth-card">
              <Card.Body>
                <div className="text-center mb-4">
                  <h3 className="fw-bold">Admin Login</h3>
                  <p className="text-muted">Sign in to your account</p>
                </div>
                
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                
                <Form onSubmit={loginhandle}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="admin@example.com"
                      value={admemail}
                      onChange={(e) => { setAdmemail(e.target.value); setFieldErrors(p => ({...p, admemail: ''})); }}
                      isInvalid={!!fieldErrors.admemail}
                    />
                    <Form.Control.Feedback type="invalid">
                      {fieldErrors.admemail}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      value={admpassword}
                      onChange={(e) => { setAdmpassword(e.target.value); setFieldErrors(p => ({...p, admpassword: ''})); }}
                      isInvalid={!!fieldErrors.admpassword}
                    />
                    <Form.Control.Feedback type="invalid">
                      {fieldErrors.admpassword}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button 
                    type="submit" 
                    className="w-100"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;